var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9e57c7e.46d2d2f"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/docs";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const dsn = process.env.SENTRY_DSN || 'https://7ee83e253e594415955d709f15b4a645@o268426.ingest.sentry.io/5772611';
const release = process.env.SENTRY_RELEASE;
const environment = process.env.APP_MODE;

const getEnvironment = (host) => {
  if (host.includes('gamedev.ol.epicgames')) {
    return 'gamedev';
  }

  if (host.includes('dev.epicgames.com')) {
    return 'prod';
  }

  return 'unknown-environment';
};

const ignoredErrors = ['Invariant: attempted to hard navigate to the same URL'];

if (release) {
  Sentry.init({
    dsn,
    // browser browser SDK will be read off of the window.SENTRY_RELEASE if available, so we need to set it manually from Next config: https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#release
    release,
    // eslint-disable-next-line no-restricted-globals
    environment: environment || getEnvironment(location.host),
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // Avast extension error
      '_avast_submit',
    ],
    beforeSend: (event, hint) => {
      const exception = hint?.originalException;
      if (exception instanceof Error) {
        for (const error of ignoredErrors) {
          if (exception.message.includes(error)) {
            return null;
          }
        }
      }
      return event;
    },
  });
} else {
  console.info(
    "sentry_init_client: Sentry release is not configured, events (exceptions, messages, etc.) won't be sent to Sentry."
  );
}
